import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ROUTER_DIRECTIVES } from '@angular/router';
import { IScenario, ScenarioService, ScenarioForecastRequest } from '../scenario-activities/scenario.service';
import { UserSession } from '../shared/user-session';

@Component({
    template: require('./scenario-reforecast-complete.component.html'),
    styles: [require('./scenario.css')],
    providers: [ScenarioForecastRequest],
    directives: [ROUTER_DIRECTIVES],
})

export class ScenarioReforecastCompleteComponent implements OnInit, OnDestroy {
    pageTitle: string = 'Scenario Reforecast Complete';
    currentScenario: IScenario;
    reforecastScenarioName: string;
    errorMessage: string;

    constructor(private _scenarioService: ScenarioService,
        private _user: UserSession,
        private _router: Router,
        private _request: ScenarioForecastRequest) { }

    ngOnInit() {
        if (typeof (this._user.scenarioId) === 'undefined')
            this._router.navigate(['./scenario-activities']);

        this._scenarioService.getScenario(this._user.getSession().scenarioId)
            .subscribe(
            scenario => this.currentScenario = scenario,
            error => this.errorMessage = <any>error
            );
        
        this.reforecastScenarioName = this._request.getNameInSession();
    }

    ngOnDestroy(){
        this._request.destroySessionValues();
    }
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-reforecast-complete.component.ts
 **/